var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { HeaderEvent, headerEventFn } from "../header/ESHeader.js";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { commonCssStyles } from "../../global-styles.js";
import { msg } from "@lit/localize";
import "../nav-menu-avatar-button/NavMenuAvatarButton.js";
import "../nav-menu-icon-button/NavMenuIconButton.js";
import "../profile-avatar/ProfileAvatar.js";
import { classMap } from "lit/directives/class-map.js";
import { AbstractDropdown } from "../dropdown-menu-mixin/AbstractDropdown.js";
/**
 * @fires CustomEvent#MY_PROFILE_CLICKED
 * @fires CustomEvent#LOG_OUT_CLICKED
 */
let ProfileDropdownMenu = class ProfileDropdownMenu extends AbstractDropdown(LitElement) {
    constructor() {
        super(...arguments);
        this.alert = false;
    }
    get dropdownContainerElement() {
        return this.shadowRoot.getElementById("dropdown-menu");
    }
    focusMenuButton() {
        this.shadowRoot.getElementById("user-avatar-btn").focus();
    }
    focusFirstDropdownItem() {
        this.shadowRoot.getElementById("dropdown-menu")
            .firstElementChild.focus();
    }
    render() {
        return html `
      <div class="container">
        <profile-avatar
          id="user-avatar-btn"
          initials="${ifDefined(this.userInitials)}"
          ?alert="${this.alert}"
          ?selected="${this.open}"
          aria-haspopup="true"
          aria-expanded="${this.open}"
          aria-controls="dropdown-menu"
          @click="${this.toggleDropdown}"
        ></profile-avatar>
        <div
          class="dropdown-visible-container ${classMap({ hide: !this.open })}"
        >
          <div
            id="dropdown-menu"
            class="dropdown-menu ${classMap({ hide: !this.open })}"
            @click="${this.toggleDropdown}"
            role="menu"
            aria-hidden="${!this.open}"
          >
            <nav-menu-avatar-button
              class="dropdown-option"
              text="${msg("My profile")}"
              initials="${ifDefined(this.userInitials)}"
              ?alert="${this.alert}"
              @click="${headerEventFn(this, HeaderEvent.MY_PROFILE_CLICKED)}"
            ></nav-menu-avatar-button>
            <hr class="divider" role="separator" aria-hidden="true" />
            <nav-menu-icon-button
              class="dropdown-option"
              text="${msg("Log out")}"
              @click="${headerEventFn(this, HeaderEvent.LOG_OUT_CLICKED)}"
            >
              <svg
                slot="icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M22.0999 12.9241L16.8473 18.067C16.3549 18.5893 15.4932 18.5893 15.0007 18.067C14.4673 17.5848 14.4673 16.7411 15.0007 16.2589L17.9963 13.2857H9.37885C8.64021 13.2857 8.06571 12.7232 8.06571 12C8.06571 11.317 8.64021 10.7143 9.37885 10.7143H17.9963L15.0007 7.78125C14.4673 7.29911 14.4673 6.45536 15.0007 5.97321C15.4932 5.45089 16.3549 5.45089 16.8473 5.97321L22.0999 11.1161C22.6334 11.5982 22.6334 12.442 22.0999 12.9241ZM8.06571 5.57143H5.43942C4.70078 5.57143 4.12628 6.17411 4.12628 6.85714V17.1429C4.12628 17.8661 4.70078 18.4286 5.43942 18.4286H8.06571C8.76331 18.4286 9.37885 19.0312 9.37885 19.7143C9.37885 20.4375 8.76331 21 8.06571 21H5.43942C3.26453 21 1.5 19.2723 1.5 17.1429V6.85714C1.5 4.72768 3.26453 3 5.43942 3H8.06571C8.76331 3 9.37885 3.60268 9.37885 4.28571C9.37885 5.00893 8.76331 5.57143 8.06571 5.57143Z"
                />
              </svg>
            </nav-menu-icon-button>
          </div>
        </div>
      </div>
    `;
    }
};
// noinspection CssUnresolvedCustomProperty
ProfileDropdownMenu.styles = [
    commonCssStyles,
    css `
      .container {
        position: relative;
        width: fit-content;
      }

      /* a mask to only show the dropdown menu below the button */
      .dropdown-visible-container {
        visibility: hidden;
        position: absolute;
        right: -32px;
        top: 57px;
        overflow: hidden;
      }

      .dropdown-menu {
        visibility: visible;
        display: flex;
        width: 200px;
        padding: 8px 16px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 0 0 8px 8px;
        background: var(--white-color, #fff);
        box-shadow:
          0 0 32px -15px rgba(115, 115, 115, 0.24),
          0 0 4px 0 rgba(115, 115, 115, 0.16);
        position: relative;
        margin: 0 32px 32px 32px;
        transform: translateY(0);
        transition: var(--dropdown-transition);
      }

      .dropdown-menu .dropdown-option {
        width: 100%;
        height: auto;
      }

      .dropdown-menu .divider {
        width: 100%;
        height: 1px;
        border: none;
        margin: 0;
        background-color: var(--neutral-dark-20-color);
      }

      .dropdown-menu.hide {
        transform: translateY(-100%);
        visibility: hidden;
      }
    `,
];
__decorate([
    property({ attribute: "user-initials" })
], ProfileDropdownMenu.prototype, "userInitials", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ProfileDropdownMenu.prototype, "alert", void 0);
ProfileDropdownMenu = __decorate([
    customElement("profile-dropdown-menu")
], ProfileDropdownMenu);
export { ProfileDropdownMenu };
